import store from '@/store/index'

const baseSnackBar = (
    severity = 'info',
    text = 'SnackBar',
) => {
    store.dispatch('snackBar', {
        text,
        severity,
        open: !store.state.optionsSnackBar.open,
    })
}
const showErrorSnackBar = (
    text,
) => {
    baseSnackBar("error", text)
}
const showSuccessSnackBar = (
    text,
) => {
    baseSnackBar("success", text)
}
const showInfoSnackBar = (
    text,
) => {
    baseSnackBar("info", text)
}

export {
    showInfoSnackBar,
    showErrorSnackBar,
    showSuccessSnackBar,
}